import { ScrollView, View } from 'react-native'
import { Portal } from 'react-native-paper'

import UniButton from '@/components/unistyles/UniButton'
import UniModal from '@/components/unistyles/UniModal'
import UniText from '@/components/unistyles/UniText'
import useModalStyles from '@/hooks/useModalStyles'

interface MedicationChangeModalProps {
  onDismiss: () => void
  visible: boolean
}

const MedicationChangeModal = ({
  onDismiss,
  visible,
}: MedicationChangeModalProps) => {
  const { styles, getModalProps } = useModalStyles()

  return (
    <Portal>
      <UniModal onDismiss={onDismiss} style={styles.modal} visible={visible}>
        <View style={styles.card}>
          <ScrollView {...getModalProps()}>
            <UniText style={styles.title} variant="titleLarge">
              Medication tracking got an upgrade!
            </UniText>
            <View style={styles.body}>
              <UniText style={{ textAlign: 'center' }} variant="bodyLarge">
                Keep track of past and upcoming medications and preventions in
                the new Medications list. You can log doses, add notes, and set
                up repeating meds and preventions.
              </UniText>
              <UniText
                style={{ marginTop: 12, textAlign: 'center' }}
                variant="bodyMedium"
              >
                We've already moved your heartworm prevention, flea/tick
                prevention, and combo med dates over automatically.
              </UniText>
            </View>
          </ScrollView>
          <UniButton
            contentStyle={styles.buttonContent}
            mode="contained"
            onPress={onDismiss}
            style={styles.primaryButton}
            testID="medication-change-modal-dismiss"
          >
            Got it
          </UniButton>
        </View>
      </UniModal>
    </Portal>
  )
}

export default MedicationChangeModal
